import { Clause18Home } from "../../pages/clause18";

export const clause18 = [
  {
    path: 'clause18',
    element: <Clause18Home />,
  },
];
